import { createRegexPagesFcmDetails } from './shared/regexPages';

export const FCM_DETAILS_OPTIMIZELY_PAGES = createRegexPagesFcmDetails('optimizely_pages', {
	scriptName: 'optimizely (third-party experiment service)',
	context: 'corgi',
});
